








































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ICProdsProviderData,
  ICProdsProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import CProdMixin from "@/mixins/cProdMixin";
import { IContractProduct } from "@/models/contracts";

@Component({
  components: {
    "cprod-grid-item": () =>
      import("@/components/app/global/contractProducts/cProdGridItem.vue")
  }
})
export default class CProdsGridView extends Mixins(Context, CProdMixin) {
  // Inject

  @Inject({ from: "cProdsProvider" })
  public cProdsProvider!: () => ICProdsProviderData;

  @Inject({ from: "cProdsProviderMethods" })
  public $cProdsMethods!: ICProdsProviderMethods;

  public get $cProdsData() {
    return this.cProdsProvider();
  }

  // Methods

  public makeNewOrder() {
    if (this.isAdmin) {
      this.$store.dispatch("data/contracts/startNewOrder");
    } else {
      this.$router.push({ name: "order" });
    }
  }

  // Computed

  public get contractProducts(): IContractProduct[] {
    if (this.$cProdsData.isLoading || !this.$cProdsData.total)
      return Array(
        this.$store.getters["ui/isMobile"]
          ? 2
          : this.$store.getters["isAdminContext"]
          ? this.$store.getters["ui/isFullHd"]
            ? this.$store.state.ui.nav.isCollapsed
              ? 12
              : 9
            : 6
          : 4
      );
    return this.$cProdsData.products;
  }

  public get showCta() {
    return this.$store.getters["brand/showStore"] && !this.isMockClientContext;
  }
}
